import React, { useState, useRef, useEffect } from "react";
import "../styles/VideoCallStyle.css";
import logo from "../Assets/images/avatar_.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophoneSlash,
  faVideo,
  faVideoSlash,
  faPhone,
  faMicrophone,
  faHand,
  faArrowUpFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { LocalUser } from "agora-rtc-react";
import "bootstrap/dist/css/bootstrap.min.css";
import ErrorModal from "./ErrorModal";
import ManyRemoteUserVideos from "./ManyRemoteUserVideos";
import ConfirmModal from "./ConfirmModal";
import { formatTime, getInitials } from "../utils/CommonFunction";
import { IMessage, IRequestUser } from "../@types/VideoCallTypes";
import { Button, Spinner } from "react-bootstrap";
import AppMessage from "../Constant/AppMessage";
import LiveComments from "./LiveComments";
import audienceicon from "../Assets/images/audience-icon.png";
import SettingBG from "./SettingBG";

type Props = {
  onPressCalling: (val: any) => void;
  onPressMic: (val: any) => void;

  calling: boolean;
  isScreenSharing: boolean;
  micOn: boolean;
  localMicrophoneTrack: any;
  screenTrack: any;
  localCameraTrack: any;
  // toggleScreenSharing: () => Promise<void>;
  permissionsGranted: {
    microphone: boolean;
    camera: boolean;
  };
  showPermissionError: boolean;
  onPressPermissionsError: () => void;
  isConnected: boolean;
  remoteUsers: any;
  isRemoteAudioOn: boolean;
  isRemoteVideoOn: boolean;
  error: string | null;
  msg: string | null;

  onPressConfirm: () => void;
  onPressClose: () => void;
  showConfirmModal: boolean;
  selectedUser: number | "local";
  onPressSelectedUser: (val: "local" | number) => void;
  onPressTabs: (val: string) => void;
  activeTab: string;
  celebProfile: any;
  sessionDetail: any;
  requestList: IRequestUser[];
  requestRightsAllow: (userId: number) => Promise<void>;
  requestRightsRevoke: (userId: number) => Promise<void>;
  loading: boolean;
  requestRejectRequest: (userId: number) => Promise<void>;
  onPressShowError: () => void;
  showError: boolean;
  enableBlur: () => Promise<void>;
  enableImage: (imgSrc: string) => Promise<void>;
  disableVirtualBackground: () => Promise<void>;
  commentList: IMessage[];
};
// Define types
type BackgroundType = "none" | "blur" | "office" | "beach" | "nature" | "space";

interface BackgroundOption {
  id: BackgroundType;
  name: string;
  icon: string;
  imageUrl?: string;
}
const OnetoMany = (props: Props) => {
  return (
    <>
      <div className="room ">
        {props.commentList && props.commentList.length > 0 && (
          <LiveComments comments={props.commentList} />
        )}
        <ConfirmModal
          showConfirmModal={props.showConfirmModal}
          onPressConfirm={props.onPressConfirm}
          onPressClose={props.onPressClose}
        />
        <ErrorModal
          showPermissionError={props.showError}
          onPressPermissionsError={props.onPressShowError}
          msg={props.error}
        />
        {props.isConnected ? (
          <div className="room__members ">
            <div className="host__user">
              <div style={{ color: "#fff" }} className="audience--icon">
                {/* Audience = ({props.sessionDetail?.count - 1}) */}
                <img src={audienceicon} alt="icon" />(
                {props.sessionDetail?.count - 1})
              </div>

              {/* remoteUser */}

              {props.selectedUser === "local" ? (
                <LocalUser
                  className="new__members"
                  audioTrack={props.localMicrophoneTrack}
                  cameraOn={true}
                  micOn={props.micOn}
                  videoTrack={props.localCameraTrack}
                  cover={
                    props.celebProfile?.profilePicture
                      ? props.celebProfile?.profilePicture
                      : logo
                  }
                  playAudio={false}
                ></LocalUser>
              ) : (
                <>
                  {props.remoteUsers
                    .filter((user: any) => user.uid === props.selectedUser)
                    .map((user: any) => (
                      <div key={user.uid}>
                        <ManyRemoteUserVideos
                          loading={props.loading}
                          sessionDetail={props.sessionDetail}
                          requestRightsRevoke={props.requestRightsRevoke}
                          remoteUsers={[user]}
                          screenView={false}
                          selectedUser={props.selectedUser}
                          onPressSelectedUser={props.onPressSelectedUser}
                          activeTab={props.activeTab}
                        />
                      </div>
                    ))}
                </>
              )}

              {props.isConnected && (
                <div className="control">
                  <div className="left-control">
                    <button
                      className="btn v_button"
                      onClick={() => props.onPressMic((a: any) => !a)}
                    >
                      {!props.micOn ? (
                        <>
                          <FontAwesomeIcon
                            icon={faMicrophoneSlash as IconProp}
                          />
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faMicrophone as IconProp} />
                        </>
                      )}
                    </button>

                    {/* Hang_up_button */}
                    <button
                      className={`btn btn-phone v_button hang_btn ${
                        props.calling ? "btn-phone-active" : ""
                      }`}
                      onClick={() => props.onPressCalling((a: any) => !a)}
                    >
                      <>
                        <i className="i-phone-hangup" />
                        <FontAwesomeIcon icon={faPhone as IconProp} />
                        <i className="i-mdi-phone" />
                      </>
                    </button>
                    <SettingBG
                      enableBlur={props.enableBlur}
                      enableImage={props.enableImage}
                      disableVirtualBackground={props.disableVirtualBackground}
                    />
                  </div>
                </div>
              )}
            </div>

            {/* small screen User */}
            <div className="members__list">
              <div className="new__members-old">
                {props.selectedUser !== "local" && (
                  <div onClick={() => props.onPressSelectedUser("local")}>
                    <LocalUser
                      className="new__members newclasss  video---center"
                      audioTrack={props.localMicrophoneTrack}
                      cameraOn={true}
                      micOn={props.micOn}
                      videoTrack={props.localCameraTrack}
                      cover={
                        props.celebProfile?.profilePicture
                          ? props.celebProfile?.profilePicture
                          : logo
                      }
                      playAudio={false}
                    ></LocalUser>
                  </div>
                )}

                {/* <div style={{ color: "#fff" }} className="audience--icon">
                  
                  <img src={audienceicon} alt="icon" />
                  {props.sessionDetail?.count - 1}
                </div> */}
                <div className="users-tabs">
                  <button
                    className={props.activeTab === "all" ? "active" : ""}
                    onClick={() => props.onPressTabs("all")}
                  >
                    Co-Host ({props.sessionDetail?.users?.length})
                  </button>

                  <button
                    className={props.activeTab === "request" ? "active" : ""}
                    onClick={() => props.onPressTabs("request")}
                  >
                    Request ({props.requestList?.length})
                  </button>
                </div>

                <div
                  className={`members_tabs_list ${
                    props.selectedUser !== "local"
                      ? "new_members_tabs_list"
                      : ""
                  }`}
                >
                  {props.activeTab === "all" && (
                    <>
                      {props.sessionDetail?.users?.length > 0 ? (
                        <div className="mb-3">
                          {props.sessionDetail.users.map((val: any) => {
                            const isRemote = props.remoteUsers.some(
                              (user: any) => user.uid == val.userId
                            );
                            return (
                              <div key={val.userId}>
                                {isRemote ? (
                                  <ManyRemoteUserVideos
                                    requestRightsRevoke={
                                      props.requestRightsRevoke
                                    }
                                    remoteUsers={props.remoteUsers.filter(
                                      (user: any) => user.uid == val.userId
                                    )}
                                    sessionDetail={props.sessionDetail}
                                    screenView={true}
                                    selectedUser={props.selectedUser}
                                    onPressSelectedUser={
                                      props.onPressSelectedUser
                                    }
                                    activeTab={props.activeTab}
                                    loading={props.loading}
                                  />
                                ) : (
                                  <div className="join__request">
                                    <div className="top">
                                      <div className="timg">
                                        <div className="um_initial">
                                          {" "}
                                          {getInitials(val.userName)}
                                        </div>
                                      </div>
                                      <div className="name">{val.userName}</div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="empty__err_msg">No User Found !</div>
                      )}
                    </>
                  )}

                  {props.activeTab === "request" && (
                    <>
                      {props.requestList.length > 0 ? (
                        <div className="request-list">
                          {props.requestList.map((user: any, index: number) => (
                            <div key={index} className="join__request">
                              <div className="top">
                                <div className="timg">
                                  {user.profilePicture ? (
                                    <img
                                      src={user.profilePicture || logo}
                                      alt={user.fullName}
                                      width={40}
                                      height={40}
                                    />
                                  ) : (
                                    <div className="um_initial">
                                      {getInitials(user.username)}
                                    </div>
                                  )}
                                </div>
                                <div className="name">{user.username}</div>
                              </div>
                              <div className="btms">
                                {props.loading ? (
                                  <Button variant="success" size="sm" disabled>
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </Button>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-success btn-sm"
                                      onClick={() =>
                                        props.requestRightsAllow(user.id)
                                      }
                                    >
                                      Allow
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() =>
                                        props.requestRejectRequest(user.id)
                                      }
                                    >
                                      Reject
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty__err_msg">No User Request !</div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="join-room">
            {props.error && <h1 className="full-page-error">{props.error}</h1>}
            {props.msg && (
              <h1 style={{ color: "lighgrey", width: "500px" }}>{props.msg}</h1>
            )}

            <ErrorModal
              showPermissionError={props.showPermissionError}
              onPressPermissionsError={props.onPressPermissionsError}
              msg={AppMessage.permissionsMsg}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default OnetoMany;
